module.exports = __webpack_public_path__ + "files/8e5f883e14f473f6be1dfa8c51bf277b.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Fraktur-Bold.woff2
// module id = 1385
// module chunks = 59